import { ModalIOF } from '@old/ui/modal/modal';
import { configButtonStylesContained } from '@old/styles/generic-styles';
import { Typography, Button, Box } from '@mui/material';
import PampaImage from '@old/assets/images/pampa-negocios.png';
import { useState } from 'react';
import WarrantIcon1 from '@old/assets/svg/warrant-list.svg';
import WarrantIcon2 from '@old/assets/svg/warrant-list2.svg';
import WarrantIcon3 from '@old/assets/svg/warrant-list3.svg';
import { useNavigate } from 'react-router';
import { PATH } from '@old/data/core/paths';
import SiloRealLogo from '@old/assets/logos/siloreal-logo-black.webp';
import { useService } from '@old/hooks/use-service';
import { updateUserDataService } from '@old/services/domain/user/base/user-edition';
import { useGlobalStore } from '@old/global-store/use-store';

type WarrantModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const STEPS = {
  INTRODUCTION: 'INTRODUCTION',
  VIDEO: 'VIDEO',
};

const infoArray = [
  {
    icon: WarrantIcon1,
    title: 'Selecciona tus silobolsas',
    text: 'Desde el listado o el detalle, elige uno o varios silobolsas que desees incluir en el warrant.',
  },
  {
    icon: WarrantIcon2,
    title: 'Completa la información',
    text: 'Si es tu primera solicitud, te pediremos cargar información básica de tu empresa, el proceso es sencillo.',
  },
  {
    icon: WarrantIcon3,
    title: 'Envío Automático',
    text: 'Tu solicitud será enviada a la entidad warrantera, te contactará para avanzar con los próximos pasos.',
  },
];

export const WarrantIntroductionModal = ({ open, setOpen }: WarrantModalProps) => {
  const [step, setStep] = useState(STEPS.INTRODUCTION);
  const navigate = useNavigate();
  const { userID, setIshowOneModal } = useGlobalStore();
  const { trigger } = useService(updateUserDataService);
  const renderContent = () => {
    switch (step) {
      case STEPS.INTRODUCTION:
        return (
          <ModalIOF.Body>
            <Typography variant="h5" sx={{ fontWeight: 500, marginBottom: 2 }}>
              Liquidez para tus SiloReales
            </Typography>
            <Typography variant="body1">
              Con SiloReal, podes obtener financiamiento utilizando tus silobolsas como garantía. Asegura
              trazabilidad, eficiencia y respaldo financiero.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                marginTop: 3,
                alignItems: 'stretch',
                padding: '20px',
                justifyContent: 'space-between',
                gap: 2,
              }}
            >
              {infoArray.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',

                    flex: 1,
                    maxWidth: '300px',
                  }}
                >
                  <img src={item.icon} alt="" style={{ width: '50px' }} />
                  <h4>{item.title}</h4>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '13px',
                      minHeight: '50px',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          </ModalIOF.Body>
        );

      case STEPS.VIDEO:
        return (
          <ModalIOF.Body>
            <iframe
              src="https://www.loom.com/embed/81262e873b1c4dfab9d477a58d289d5f?sid=051efa46-94e4-4e6d-ae8f-5bb634cc37cf"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                width: '100%',
                height: '500px',
                borderRadius: '8px',
              }}
              title="Video Tutorial"
            ></iframe>
          </ModalIOF.Body>
        );
    }
  };

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen} width={'1100px'}>
      <ModalIOF.Header>
        <ModalIOF.Title>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <div style={{ borderRight: '1px solid #a2a2a0', paddingRight: '10px' }}>
              <img style={{ width: '120px' }} src={SiloRealLogo} alt="" />
            </div>
            <img style={{ width: '120px', marginRight: '10px' }} src={PampaImage} alt="" />
          </div>
        </ModalIOF.Title>
      </ModalIOF.Header>

      <ModalIOF.Body>
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          {renderContent()!}
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }}>
            <Button
              variant="text"
              onClick={() => {
                setOpen(false);
                setIshowOneModal(true);
                trigger({
                  query: userID!,
                  body: { was_warrant_popup_shown: true },
                });
              }}
              sx={{ color: 'black', textTransform: 'none', marginRight: '10px' }}
            >
              Quizás más tarde
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                if (step === STEPS.INTRODUCTION) {
                  setStep(STEPS.VIDEO);
                } else {
                  setIshowOneModal(true);
                  trigger({
                    query: userID!,
                    body: { was_warrant_popup_shown: true },
                  });
                  navigate(PATH.WARRANTS);
                }
              }}
              sx={{
                ...configButtonStylesContained,
                width: { xs: '95%', md: '180px' },
                backgroundColor: '#00AFEF',
                color: '#FFF',
              }}
            >
              {step === STEPS.INTRODUCTION ? 'Continuar' : 'Solicitar Warrant'}
            </Button>
          </div>
        </div>
      </ModalIOF.Body>
    </ModalIOF>
  );
};
